// Documentation: https://docs.rollbar.com/docs/vue-js

import Vue from 'vue'
import VueRollbar from 'vue-rollbar'
import store from './vuex'
import { DOMAIN } from './paths'

let enabled = false
let errorsNotSent = []
let globalVariablesAreSet = false

window.addEventListener('on:global-vars-set', () => {
  globalVariablesAreSet = true
})

Vue.config.errorHandler = function(err) {
  enabled ? Vue.rollbar.error(err) : errorsNotSent.push(err)
  console.error(err) // eslint-disable-line no-console
}

Vue.use(VueRollbar, {
  accessToken: __ROLLBAR_ACCESS_TOKEN__, // eslint-disable-line no-undef
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled,
  environment: process.env.TARGET_ENV,
  hostWhiteList: [DOMAIN],
  ignoredMessages: [
    'Script error.',
    'The network connection was lost.',
    'A network error occurred.',
    'The operation was aborted.',
  ],
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: __GIT_REVISION__, // eslint-disable-line no-undef
        // Optionally have Rollbar guess which frames the error was thrown from
        // when the browser does not provide line and column numbers.
        guess_uncaught_frames: true,
      },
    },
  },
})

function enableVueRollbar(checkIgnore) {
  enabled = true
  const config = { enabled }
  if (checkIgnore) config.checkIgnore = checkIgnore
  Vue.rollbar.configure(config)

  const configurePersonId = () => {
    Vue.rollbar.configure({
      payload: {
        person: {
          id: window.USER_ACCOUNT_DATA.id,
        },
      },
    })
  }
  globalVariablesAreSet
    ? configurePersonId()
    : window.addEventListener('on:global-vars-set', configurePersonId)

  store.watch(
    () => store.getters['account/currentUser'],
    currentUser => {
      if (!currentUser) return

      Vue.rollbar.configure({
        payload: {
          person: {
            id: currentUser.id,
            email: currentUser.email,
          },
        },
      })
    },
    {
      immediate: true,
    }
  )
  errorsNotSent.forEach(err => Vue.rollbar.error(err))
  errorsNotSent = []
}

On.enableVueRollbar = enableVueRollbar
